const DEFAULT_HEADERS = {
  'Content-Type': 'application/json;charset=utf-8',
};
const GET_METHOD = 'GET';

function fetchRequest(url, options = {}) {
  return fetch(url, options);
}

export class RequestAPI {
  constructor(baseURL, headers = {}) {
    this.baseURL = baseURL;
    this.headers = Object.assign({}, DEFAULT_HEADERS, headers);
  }

  makeFullURL = (route) => {
    return `${this.baseURL}/${route}`;
  };

  get = async (route, headers = {}) => {
    try {
      const requestOptions = {method: GET_METHOD, headers};
      const requestURL = this.makeFullURL(route);
      const response = await fetchRequest(requestURL, requestOptions);
      if (response.ok) {
        const responseJSON = await response.json();
        return responseJSON;
      } else {
        throw new Error(`HTTP Error: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };
}
